import { NodeObject } from "./common/ah.mb.common.node-object";
import { ModelNotifier } from "./model-notifier";
import { FetchWrapper } from "../infrastructure/fetch-wrapper";
import { IBasicCommandResponse } from "./ah.mb.client-notifications";
import { IReportParams, IEditReportModel, ICreateReportModel } from "../entities/edit-report-model";
import { ViewDef } from "../scripts/ah.mb.ui.view-builders";

// Report services


export class ReportServices {

    // Private declarations
    private readonly modelObserver: ModelNotifier;

    private rootApiUrl = "/api/1.0";

    private scriptsRootUrl = this.rootApiUrl + "/reportscripts";
    private createScriptUrl = this.scriptsRootUrl;

    private reportsRootUrl = this.rootApiUrl + "/reports";


    // Constructor
    constructor(modelObserver: ModelNotifier) {
        this.modelObserver = modelObserver;
    }

    // Creares a new model
    createScript = (modelId: string, parentNode: string, name: string,
        nodePathAndName: string): Promise<IBasicCommandResponse> => {

        var payload = {
            modelId: modelId,
            parentNode: parentNode,
            name: name,
            nodePathAndName: nodePathAndName
        };

        return FetchWrapper.sendCommandAndHandle(this.createScriptUrl,
            { method: "post", body: JSON.stringify(payload) })
            .then(data => {

                // Notify node observer
                var nodeInfo = new NodeObject(parentNode + "\\" + name,
                    "ReportFolderNode",
                    true, "");
                this.modelObserver.notifyNodeCreated(nodeInfo, {});
                return data;
            });
    }

    // Creates a new model
    deleteScript = (modelId, scriptName, successCallback) => {

        var url = this.scriptsRootUrl + "/" + modelId + "/delete";

        var payload = { scriptName: scriptName };

        $.ajax({
            type: "POST",
            data: JSON.stringify(payload),
            contentType: "application/json",
            url: url,
            success: (data) => {
                successCallback();
            }
        });

    }

    // Edits a script
    editScript = (modelId: string, scriptName: string,
        name: string, node: string): Promise<IBasicCommandResponse> => {

        var url = this.scriptsRootUrl + "/" + modelId + "/" + "edit";

        var payload = { modelId: modelId, scriptName: scriptName, name: name, nodePathAndName: node };

        return FetchWrapper.sendCommandAndHandle(url,
            { method: "post", body: JSON.stringify(payload) })

            //return $.post({
            //        //type: "POST",
            //        data: JSON.stringify(payload),
            //        contentType: "application/json",
            //        dataType: "json",
            //        url: url
            //    })
            .then(data => {

                // Notify node observer
                this.modelObserver.notifyNodeRenamed(scriptName, name);
                return data;
            });

    }

    createReport(modelId: string,
        value: ICreateReportModel): Promise<IBasicCommandResponse> {

        const url = this.reportsRootUrl + "/" + modelId;

        return FetchWrapper.sendCommandAndHandle(url,
            { method: "post", body: JSON.stringify(value) })
            .then((data) => {
                if (data.success) {
                    const nodeInfo = new NodeObject(value.scriptName + "\\" + value.name,
                        "Report",
                        false,
                    "");
                    this.modelObserver.notifyNodeCreated(nodeInfo, {});
                }


                return data;
            });

    }

    editReport = (modelId: string, value: IEditReportModel): Promise<IBasicCommandResponse> => {

        var url = this.reportsRootUrl + "/" + modelId + "/edit";

        return FetchWrapper.sendCommandAndHandle(url,
            { method: "post", body: JSON.stringify(value) })

            .then((data) => {
                // Notify node observer
                if (data.success) {
                    if (NodeObject.extractName(value.reportName) !== value.newName)
                        this.modelObserver.notifyNodeRenamed(value.reportName, value.newName);
                }
                return data;
            });


    }


    // Download reports function
    downloadReports = (modelId: string, reportIds: string[], format : "excel" | "csv"| "json",
        createPivot: boolean, singleSheet: boolean, recursive: boolean):
        Promise<any> => {

        var reportIdsUrl = "";
        for (var i = 0; i < reportIds.length; i++) {
            if (i > 0)
                reportIdsUrl = reportIdsUrl + "&";
            reportIdsUrl = reportIdsUrl + "reportIds=" + reportIds[i];

        }

        var actionUrl = "";
        switch (format) {
            case "json": actionUrl = "downloadjson"; break;
            case "csv": actionUrl = "downloadcsv"; break;
            default: actionUrl = "download"; break;
        }

        var url = this.reportsRootUrl +
            "/" +
            modelId
            + "/"
            + actionUrl
            + "?createPivots=" + createPivot
            + "&singleSheet=" + singleSheet
            + "&recursive=" + recursive
            + "&" + reportIdsUrl;

        url = encodeURI(url);

        // Ajax does not allow file downloading, do it this way
        window.location.href = url;

        return Promise.resolve(); // $.Deferred().resolve();
    }


    // Download reports function
    downloadReportsByNode = (modelId: string, nodePathAndNames: string[], reportNames: string[], format: "excel" | "csv" | "json",
        createPivot: boolean): Promise<any> => {

        var reportIdsUrl = "";
        for (let i = 0; i < reportNames.length; i++) {
            reportIdsUrl = reportIdsUrl + "&reportNames=" + reportNames[i];
        }

        var nodePathAndNamesUrl = "";
        for (let i = 0; i < nodePathAndNames.length; i++) {
            nodePathAndNamesUrl = nodePathAndNamesUrl + "&nodePathAndNames=" + nodePathAndNames[i];
        }

        var url = this.reportsRootUrl +
            "/" +
            modelId +
            "/downloadbynode" +
            "?format=" +
            format +
            "&createPivots=" +
            createPivot +
            nodePathAndNamesUrl +
            reportIdsUrl;

        url = encodeURI(url);

        // Ajax does not allow file downloading, do it this way
        window.location.href = url;

        return Promise.resolve();
    }

    downloadModelRecordsStreamByDefinition(modelId: string, definitionNodePathAndName: string,
        format: "excel" | "csv" | "json",  reportNodePathAndNames: string[]): Promise<any> {
        var urlParams = new URLSearchParams();
        urlParams.set("format", format);
        urlParams.set("definitionNodePathAndName", definitionNodePathAndName);
        reportNodePathAndNames.forEach(value => urlParams.append("reportNodePathAndNames", value));

        var url = `/api/1.0/reports/${modelId}/exportmodelrecordsbydefinition/?${urlParams.toString()}`;

        //url = encodeURI(url);

        // Ajax does not allow file downloading, do it this way
        window.location.href = url;

        return Promise.resolve();

    }

    downloadModelRecordsStream (modelId: string, resultType: "Link Data" | "Report Results",
        query: string[], recordSetName: string, format: "excel" | "csv" | "json",
        nodePathAndNames: string[]): Promise<any> {

        var urlParams = new URLSearchParams();
        urlParams.set("resultType", resultType);

        query.forEach(value => urlParams.append("query", value));
        urlParams.set("recordSetName", recordSetName);
        urlParams.set("format", format);
        nodePathAndNames.forEach(value => urlParams.append("nodePathAndNames", value));
        //};

        //var urlParams = new URLSearchParams(paramsObj).toString();

        var url = `/api/1.0/reports/${modelId}/exportmodelrecords/?${urlParams.toString()}`;

        //url = encodeURI(url);

        // Ajax does not allow file downloading, do it this way
        window.location.href = url;

        return Promise.resolve();
    }


    getReportParams(modelId, reportName): Promise<IReportParams> {

        var url = this.reportsRootUrl + "/" + modelId + "?reportName=" + reportName;

        url = encodeURI(url);
        return FetchWrapper.fetch(url, { method: "get" })
            .then(result => result.json())
    }

    getReportByNodeResults = (modelId,
        nodePathAndNames,
        reportName,
        queryString: string): JQueryPromise<any> => {

        var url = this.reportsRootUrl +
            "/" +
            modelId +
            "/reportbynoderesults" +
            "?reportName=" +
            reportName;

        url = `${url}&queryString=${queryString}`;

        url = `${url}&nodePathAndNames=${nodePathAndNames[0]}`;

        for (let i = 1; i < nodePathAndNames.length; i++)
            url = url + "&nodePathAndNames=" + nodePathAndNames[i];

        url = encodeURI(url);

        return $.ajax({
            type: "GET",
            url: url,
            global: false, // Suppress global ajax notification
        });
    }

    // Gets the url for returning the reports of multiple scripts
    getReportListUrl = (modelId) => {
        return "scriptreports/indexasdatatable";
        //return this.reportsRootUrl + '/' + modelId + '/indexasdt';
    }

    // Gets report tooltip
    getReportSummaryText = (modelId, reportId) => {
        this.getReportParams(modelId,
            reportId)
            .then(data => data.sector);
    }

    // Gets list of reports by nodes
    getReportsByNodes = (modelId: string, reportTypeFilter: "All" | "Custom" | "Automatic" | "NodeContext" | "AllIncludingNodeContext" | "Maps" 
        ,nodePathAndNames: string[], queryString: string): Promise<ViewDef[]> => {

        var url = this.reportsRootUrl +
            "/" +
            modelId +
            "/reportsbynodes" +
            "?reportTypeFilter=" +reportTypeFilter +
            "&nodePathAndNames=" +nodePathAndNames[0] +
            "&queryString=" + queryString;

        for (let i = 1; i < nodePathAndNames.length; i++)
            url = url + "&nodePathAndNames=" + nodePathAndNames[i];

        url = encodeURI(url);

        return FetchWrapper.fetch(url, { method: "get" })
            .then(response => response.json());
    }

    getReportData = (modelId: string, format: string, reportIds, callback) => {

        var url = this.reportsRootUrl + "/" + modelId + "/reportresults?format=" + format + "&reportIds=" + reportIds[0];

        for (let i = 1; i < reportIds.length; i++)
            url = url + "&reportIds=" + reportIds[i];

        url = encodeURI(url);

        $.ajax({
            type: "GET",
            url: url,
            global: false, // Suppress global ajax notification
            success: data => {
                callback(data);
            }
        });
    }

    // Exports scripts func
    exportScripts = (modelId, scriptNames, successCallback) => {
        var url = this.scriptsRootUrl + "/" + modelId + "/export" + "?scriptNames=" + scriptNames[0];

        for (let i = 1; i < scriptNames.length; i++)
            url = url + "&scriptNames=" + scriptNames[i];

        url = encodeURI(url);

        // Ajax does not allow file downloading, do it this way
        window.location.href = url;

    }

    // Import scripts func
    importScripts = (modelId, formData, successCallback) => {

        formData.append("modelId", modelId);

        var url = this.scriptsRootUrl + "/" + modelId + "/import";

        url = encodeURI(url);

        $.ajax({
            url: url,
            type: "POST",
            data: formData,
            success: (data) => {
                successCallback(data);
            },
            cache: false,
            contentType: false,
            processData: false
        });
    }

    copyScripts = (modelId, scriptNames, scriptName, nodePathAndName, successCallback) => {
        var url = this.scriptsRootUrl + "/" + modelId + "/copy";

        var payload = {
            modelId: modelId,
            scriptNames: scriptNames,
            scriptName: scriptName,
            nodePathAndName: nodePathAndName
        };

        $.ajax({
            type: "POST",
            data: JSON.stringify(payload),
            contentType: "application/json",
            url: url,
            success: (data) => {
                successCallback();
            }
        });
    }

    /**
* Gets the report tree ajax url
* @param {} modelId 
* @returns {} 
*/
    getReportTreeAjaxUrl = (modelId) => {
        // var nodePlaceholder = "%rootNode%";

        var url =
            this.rootApiUrl + "/reportree";
        //    + '?modelId='
        //    + modelId
        //+ '&rootNode=' + nodePlaceholder;

        return url;
    }

    restoreAutomaticReports(modelId: string): Promise<IBasicCommandResponse> {
        return FetchWrapper.sendCommandAndHandle("/api/1.0/reports/restoreautomatic",
            { method: "post", body: JSON.stringify({ modelId: modelId }) });


    }


}






// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.report-services.ts